import { BLOQUEAR_POLTRONA_JA_MARCADO_ITINEARARIO_VOLTA } from '../types'

export default function bloquearPoltronaJaMarcadoItinerarioVolta (assento, fileira) {
  return {
    type: BLOQUEAR_POLTRONA_JA_MARCADO_ITINEARARIO_VOLTA,
    payload: { assento, fileira }
  }
}
